<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t(type) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'accountingList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('accountingList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <template>
              <v-text-field
                id="fromDate"
                v-model="fromDate"
                :label="$t('fromDate')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromDate"
                element="fromDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="$store.state.financialYear.start_date"
                :max="$store.state.financialYear.end_date"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <template>
              <v-text-field
                id="toDate"
                v-model="toDate"
                :label="$t('toDate')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="toDate"
                element="toDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="$store.state.financialYear.start_date"
                :max="$store.state.financialYear.end_date"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <v-text-field
              v-model="fromNum"
              height="20"
              dense
              outlined
              class="dense"
              clearable
              :label="$t('from-number')"
              ref="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <v-text-field
              v-model="toNum"
              height="20"
              dense
              outlined
              class="dense"
              clearable
              :label="$t('toNumber')"
              ref="number"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="loading"
              @click="submit"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'blue')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from '../../../../Mixins/general'
export default {
  name: 'Product',
  components: {
  },
  mixins: [General],
  props: ['formType'],
  data: () => ({
    options: {
      locale: 'en-US',
      prefix: '',
      suffix: ' ',
      precision: 0
    },
    render: false,
    isLoading: false,
    alert: false,
    tag: null,
    content: null,
    valid: null,
    message: null,
    alertType: null,
    name: null,
    type: null,
    id: null,
    status: 'active',
    group: null,
    loading: false,
    fromNum: null,
    toNum: null,
    fromDate: null,
    toDate: null
  }),
  watch: {
    snakbar () {
    }
  },
  beforeMount () {
    if (this.$route.name === 'documentNumbering') {
      this.type = 'documentNumbering'
    }
    if (this.$route.name === 'ConvertTempToPermanentDocuments') {
      this.type = 'ConvertTempToPermanentDocuments'
    }
    this.to = this.$store.state.financialYear.end_date
    if (this.$route.params.id != null) {
      this.show()
      this.id = this.$route.params.id
      this.render = false
    } else {
      this.render = true
    }
  },
  mounted () {
  },
  methods: {
    submit () {
      var app = this
      app.loading = true
      app.$axios.get(app.$endpoint + 'accounting', {
        params: {
          fixDocument: app.type,
          fromNum: app.fromNum,
          toNum: app.toNum,
          fromDate: app.fromDate,
          toDate: app.toDate
        }
      })
        .then(res => {
          res = res.data
          app.snakbarText = app.$t('opertationSuccess')
          app.snakbarColor = 'green'
          app.snakbar = true
        })
        .catch(err => {
          app.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>

</style>
